module.exports = __webpack_public_path__ + "img/36548171000105.c97b6f0a.png";